// @flow
import * as React from 'react';

import ThumbnailCard from './ThumbnailCard';
import notes from './ThumbnailCard.stories.md';

const thumbnail = <div>Thumbnail</div>;
const title = 'Title';

export const basic = () => <ThumbnailCard thumbnail={thumbnail} title={title} />;

export const highlightOnHover = () => <ThumbnailCard highlightOnHover thumbnail={thumbnail} title={title} />;

export default {
    title: 'Components|ThumbnailCard',
    component: ThumbnailCard,
    parameters: {
        notes,
    },
};
